import { render } from "./resetPassword.vue?vue&type=template&id=607badbb"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"
script.render = render

export default script